import { Component, computed, inject } from '@angular/core'
import { NgComponentOutlet } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { SidePanelService } from './side-panel.service'

@Component({
    selector: 'app-side-panel',
    templateUrl: './side-panel.component.html',
    styleUrl: './side-panel.component.scss',
    imports: [NgComponentOutlet, TranslateModule],
})
export class SidePanelComponent {
    panel = inject(SidePanelService)

    /**
     * Mappa token → inputs del componente per ogni layer nello stack.
     * Ogni componente riceve panelMode:true e il proprio panelLayerToken
     * in aggiunta agli inputs dichiarati nel config.
     */
    allInputs = computed(() => {
        const map = new Map<number, Record<string, unknown>>()
        for (const entry of this.panel.stack()) {
            map.set(entry.token, {
                panelMode: true,
                panelLayerToken: entry.token,
                ...(entry.config.inputs ?? {}),
            })
        }
        return map
    })
}
